<template>
  <v-card
    elevation="0"
    class="options pb-1"
  >
    <v-toolbar
      flat
      class="options__toolbar"
    >
      <v-toolbar-title
        class="options__title"
        :style="{ 'color': appColor.textDark }"
      >
        Параметры подписи
      </v-toolbar-title>
    </v-toolbar>
    <div class="pl-4 pr-4">
      <v-radio-group
        :value="define"
        class="mb-3"
        hide-details
        column
        @change="$emit('defineChange', $event)"
      >
        <v-radio
          v-for="type of signatureDefine"
          :key="type.value"
          :color="appColor.secondary"
          :value="type.value"
        >
          <template #label>
            <div
              style="opacity: 0.9"
              :style="{ 'color': `${appColor.textDark} !important` }"
            >
              {{ type.label }}
            </div>
          </template>
        </v-radio>
      </v-radio-group>
      <v-expand-transition>
        <div v-show="define === 'manually'">
          <v-divider />

          <div v-if="policies.Version === 2">
            <v-checkbox
              :input-value="includeChain"
              class="align-self-start mt-2 mb-3"
              :color="appColor.secondary"
              hide-details="auto"
              @change="$emit('includeChainChange', $event)"
            >
              <template #label>
                <div
                  style="opacity: 0.9"
                  :style="{ 'color': `${appColor.textDark} !important` }"
                >
                  Добавить цепочку сертификата подписи в результат проверки
                </div>
              </template>
            </v-checkbox>
            <v-divider />
          </div>

          <v-radio-group
            :value="format"
            hide-details
            class="mb-4"
            column
            @change="$emit('formatChange', $event)"
          >
            <v-radio
              v-for="item in filteredFormats"
              :key="item.value"
              :color="appColor.secondary"
              :value="item.value"
              :style="item.value === 'GOST3410' ? 'margin-bottom: 0' : null"
            >
              <template #label>
                <div
                  style="opacity: 0.9"
                  :style="{ 'color': `${appColor.textDark} !important` }"
                >
                  {{ item.label }}
                </div>
              </template>
            </v-radio>
            <v-expand-transition>
              <p
                v-show="format === 'GOST3410' && !certificateAdded"
                class="mb-0 pl-8 hint-text"
                :style="{ 'color': `${appColor.error} !important` }"
              >
                Необходимо прикрепить сертификат
              </p>
            </v-expand-transition>
          </v-radio-group>
        </div>
      </v-expand-transition>
      <v-expand-transition>
        <div v-show="sigParamsActive">
          <v-divider style="height: 1px;" />
          <v-radio-group
            :value="sigType"
            column
            @change="$emit('sigTypeChange', $event)"
          >
            <v-radio
              v-for="type of signatureType"
              :key="type.value"
              :color="appColor.secondary"
              :value="type.value"
            >
              <template #label>
                <div
                  style="opacity: 0.9"
                  :style="{ 'color': `${appColor.textDark} !important` }"
                >
                  {{ type.label }}
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-expand-transition>
            <v-select
              v-show="algorithmSelectActive"
              outlined
              hide-details
              :items="algorithmList"
              :value="algorithm"
              class="mb-5"
              :item-color="appColor.secondary"
              :color="appColor.secondary"
              @input="$emit('algorithmChange', $event)"
            >
              <template #item="{ item }">
                <div :style="{ 'color': appColor.textDark }">
                  {{ item.text }}
                </div>
              </template>
              <template #selection="{ item }">
                <div :style="{ 'color': appColor.textDark }">
                  {{ item.text }}
                </div>
              </template>
              <template #label>
                <div
                  style="opacity: 0.9"
                  :style="{ 'color': appColor.textDark }"
                >
                  Алгоритм хэширования
                </div>
              </template>
            </v-select>
          </v-expand-transition>
          <v-btn
            class="options__btn mb-5"
            :color="`${appColor.secondary} !important`"
            @click="$emit('addCertificate')"
          >
            <v-icon
              left
              size="22"
            >
              bi-paperclip
            </v-icon>
            Прикрепить сертификат
          </v-btn>
        </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SignatureOptions',

  props: {
    define: {
      type: String,
      required: true,
      default: 'auto'
    },
    format: {
      type: String,
      required: false,
      default: 'PDF'
    },
    includeChain: {
      type: Boolean,
      required: false,
      default: false
    },
    sigType: {
      type: String,
      required: false,
      default: 'dataSign'
    },
    algorithm: {
      type: String,
      required: false,
      default: 'GR 34.11-2012 256'
    },
    certificateAdded: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      signatureDefine: [
        { label: 'Автоматически (на основании расширений файлов)', value: 'auto' },
        { label: 'Задается вручную', value: 'manually' }
      ],
      formatsList: [
        { label: 'Подпись документов PDF', value: 'PDF' },
        { label: 'Подпись документов Word и Excel', value: 'MSOffice' },
        { label: 'Подпись документов XML (XML Digital Signature)', value: 'XMLDSig' },
        { label: 'Подпись в формате CMS', value: 'CMS' },
        { label: 'Необработанная подпись', value: 'GOST3410' }
      ],
      algorithmList: [
        { text: 'GR 34.11-2012 256', value: 'GR 34.11-2012 256' },
        { text: 'GR 34.11-2012 512', value: 'GR 34.11-2012 512' },
        { text: 'SHA-1', value: 'SHA-1' },
        { text: 'SHA-256', value: 'SHA-256' },
        { text: 'SHA-384', value: 'SHA-384' },
        { text: 'SHA-512', value: 'SHA-512' },
        { text: 'MD5', value: 'MD5' },
        { text: 'GOST R 34.11-94', value: 'GOST R 34.11-94' }
      ],
      signatureType: [
        { label: 'Подпись данных', value: 'dataSign' },
        { label: 'Подпись значения хэш-функции', value: 'hashSign' }
      ],
      appColor: this.$appConfig.color
    }
  },

  computed: {
    ...mapState(['policies']),

    filteredFormats () {
      const filter = this.policies.SignatureDescriptions.map(desc => desc.SignatureType)
      return this.formatsList.filter(format => filter.includes(format.value))
    },

    cmsActive () {
      return this.define === 'manually' && this.format === 'CMS'
    },

    sigParamsActive () {
      return this.cmsActive ||
        (this.define === 'manually' && this.format === 'GOST3410')
    },

    algorithmSelectActive () {
      return (this.cmsActive && this.sigType === 'hashSign') ||
        (this.define === 'manually' && this.format === 'GOST3410')
    }
  }
}
</script>

<style lang="scss" scoped>
  .options {
    border-radius: $default-border-radius;

    &__toolbar {
      border-bottom: 1px solid $color-divider;
    }

    &__title {
      margin: auto;
    }

    &__btn {
      width: 100%;
      height: 50px !important;

      @include cp-button;
    }
  }

  .hint-text {
    font-size: 13px;
    color: $color-main-dark;
    opacity: 0.75;
  }
</style>
